import * as React from 'react'
import { Editor, EditorState, ContentState } from 'draft-js'
import 'draft-js/dist/Draft.css'

export interface SampleEditorProps {
  initialText?: string
}

export function SampleEditor({ initialText }: SampleEditorProps) {
  const [editorState, setEditorState] = React.useState(() =>
    EditorState.createWithContent(ContentState.createFromText(initialText ?? ''))
  )

  return (
    <div className="sampleeditor">
      <Editor editorState={editorState} onChange={setEditorState} />
    </div>
  )
}
